/**
 * 从当前页 base 拼接静态资源 URL（支持子路径部署）
 */
export function assetUrl(relativePath: string): string {
  const base = import.meta.env.BASE_URL || "/";
  const norm = base.endsWith("/") ? base : `${base}/`;
  return `${norm}${relativePath.replace(/^\//, "")}`;
}
